if (!customElements.get('dl-article-faqs')) {
  customElements.define(
    'dl-article-faqs',
    class DlArticleFaqs extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.dl-article-template__faqs-item-header').forEach((header) => {
          header.addEventListener('click', this.onHeaderClick.bind(this));
        });
      }

      onHeaderClick(e) {
        const item = e.currentTarget.closest('.dl-article-template__faqs-item');
        if (!item) return;
        const isOpen = item.classList.contains('is-open');
        // 关闭所有已展开的项
        this.querySelectorAll('.dl-article-template__faqs-item.is-open').forEach((openItem) => {
          openItem.classList.remove('is-open');
          openItem.querySelector('.dl-article-template__faqs-item-content').style.height = '0';
        });
        // 若当前项原本是关闭的则展开
        if (!isOpen) {
          item.classList.add('is-open');
          const content = item.querySelector('.dl-article-template__faqs-item-content');
          content.style.height = content.scrollHeight + 'px';
        }
      }
    }
  );
}

if (!customElements.get('dl-article-related')) {
  customElements.define(
    'dl-article-related',
    class DlArticleRelated extends HTMLElement {
      connectedCallback() {
        this.glideEl = this.querySelector('.dl-article-template__related-articles-glide');
        if (!this.glideEl) return;
        this.windowWidth = window.innerWidth;
        this._onResize = this.onResize.bind(this);
        setTimeout(() => this.initGlide(), 0);
        window.addEventListener('resize', this._onResize);
      }

      disconnectedCallback() {
        this.glide?.destroy();
        window.removeEventListener('resize', this._onResize);
      }

      initGlide() {
        this.glide?.destroy();
        const isMobile = window.innerWidth < 990;
        this.glide = new Glide(this.glideEl, {
          type: 'slider',
          rewind: false,
          perView: isMobile ? 1.3 : 3,
          gap: 19,
          bound: true,
        });
        this.glide.mount();
      }

      onResize() {
        if (this.windowWidth === window.innerWidth) return;
        this.windowWidth = window.innerWidth;
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this.initGlide(), 200);
      }
    }
  );
}

if (!customElements.get('dl-article-sidebar')) {
  customElements.define(
    'dl-article-sidebar',
    class DlArticleSidebar extends HTMLElement {
      connectedCallback() {
        // 读取 TOC 区域高度，供 ads-sidebar 定位使用
        const tocContent = this.querySelector('.dl-article-template__sidebar-content');
        if (tocContent) {
          const syncTocHeight = () => {
            this.style.setProperty('--toc-height', tocContent.offsetHeight + 'px');
          };
          syncTocHeight();
          this._syncTocHeight = syncTocHeight;
          window.addEventListener('resize', this._syncTocHeight);
        }

        // 广告和订阅切换不依赖 TOC，需要在 TOC 的提前退出之前初始化。
        this.adsSidebarClose = this.querySelector('.dl-article-template__ads-sidebar-close');
        this.adsSidebar = this.querySelector('.dl-article-template__ads-sidebar');
        this.subscribeWrapper = this.querySelector('.dl-article-template__subscribe');

        if (this.adsSidebarClose) {
          this._onAdsSidebarCloseClick = this.onAdsSidebarCloseClick.bind(this);
          this.adsSidebarClose.addEventListener('click', this._onAdsSidebarCloseClick);
        }

        const isAdsPreviouslyClosed = localStorage.getItem('dl-article-ads-sidebar-closed') === 'true';
        if (this.adsSidebar && !isAdsPreviouslyClosed) {
          this.adsSidebar.classList.add('dl-show');
          this.subscribeWrapper?.classList.remove('dl-show');
        } else {
          // 无广告或广告此前已关闭，直接显示订阅区（若用户未 dismiss）
          this.showSubscribeIfNeeded();
        }

        this.tocLinks = this.querySelectorAll('.dl-article-template__toc-list a[href^="#"]');
        if (!this.tocLinks.length) return;

        const article = this.closest('.dl-main-article-m');
        if (!article) return;

        this.headings = Array.from(
          article.querySelectorAll('.dl-article-template__content :is(h1, h2, h3, h4, h5, h6)[id]')
        );
        if (!this.headings.length) return;

        this.linkMap = new Map();
        this.tocLinks.forEach((link) => {
          const id = link.getAttribute('href').slice(1);
          this.linkMap.set(id, link);
          link.addEventListener('click', this.onTocClick.bind(this));
        });

        this.activeId = null;
        this._onResize = this.onResize.bind(this);
        window.addEventListener('resize', this._onResize);
        this.initObserver();

      }
      isSubscribeDismissed() {
        return document.cookie.split(';').some((c) => c.trim().startsWith('dl_subscribe_dismissed='));
      }
      showSubscribeIfNeeded() {
        if (this.isSubscribeDismissed()) return;
        // bottom 模式或手机端由滚动监听控制，这里不立即显示
        const isBottomMode = this.subscribeWrapper?.classList.contains('layout-bottom') || window.innerWidth <= 990;
        if (isBottomMode) return;
        this.subscribeWrapper?.classList.add('dl-show');
      }
      onAdsSidebarCloseClick() {
        this.adsSidebar.classList.remove('dl-show');
        localStorage.setItem('dl-article-ads-sidebar-closed', 'true');
        this.showSubscribeIfNeeded();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this._onAdsSidebarCloseClick) {
          this.adsSidebarClose?.removeEventListener('click', this._onAdsSidebarCloseClick);
        }
        if (this._syncTocHeight) {
          window.removeEventListener('resize', this._syncTocHeight);
        }
        if (this._onResize) {
          window.removeEventListener('resize', this._onResize);
        }
      }

      getScrollOffset() {
        const sidebarContent = this.querySelector('.dl-article-template__sidebar-content');
        if (sidebarContent) {
          const top = parseFloat(getComputedStyle(sidebarContent).top);
          if (!Number.isNaN(top) && top > 0) return top;
        }
        const blogNav = document.querySelector('.dl-blog-navigation-root');
        if (blogNav) return blogNav.getBoundingClientRect().height + 16;
        return 104;
      }

      initObserver() {
        this.observer?.disconnect();
        const offset = this.getScrollOffset();
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          rootMargin: `-${offset}px 0px -60% 0px`,
          threshold: 0,
        });
        this.headings.forEach((h) => this.observer.observe(h));
      }

      onResize() {
        clearTimeout(this._observerResizeTimer);
        this._observerResizeTimer = setTimeout(() => this.initObserver(), 200);
      }

      onTocClick(e) {
        e.preventDefault();
        const id = e.currentTarget.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - this.getScrollOffset();
        window.scrollTo({ top, behavior: 'smooth' });
        this.setActive(id);
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          entry.target._isVisible = entry.isIntersecting;
        });

        const visible = this.headings.filter((h) => h._isVisible);
        if (visible.length) {
          this.setActive(visible[0].id);
          return;
        }

        // 全都不在检测区时，找滚过视口顶部最近的 heading
        const scrollY = window.scrollY;
        const offset = this.getScrollOffset();
        for (let i = this.headings.length - 1; i >= 0; i--) {
          if (this.headings[i].getBoundingClientRect().top + scrollY < scrollY + offset) {
            this.setActive(this.headings[i].id);
            return;
          }
        }
      }

      setActive(id) {
        if (id === this.activeId) return;
        this.activeId = id;
        this.tocLinks.forEach((link) => link.parentElement.classList.remove('is-active'));
        this.linkMap.get(id)?.parentElement.classList.add('is-active');
      }
    }
  );
}

if (!customElements.get('dl-blog-upsell')) {
  customElements.define(
    'dl-blog-upsell',
    class DlBlogUpsell extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.dl-blog-upsell');
        this.previousButton = this.querySelector('.dl-blog-upsell-nav--prev');
        this.nextButton = this.querySelector('.dl-blog-upsell-nav--next');
        this._onClick = this.onClick.bind(this);
        this.addEventListener('click', this._onClick, true);
        if (!this.scroller || !this.previousButton || !this.nextButton) return;

        this._onScroll = () => this.updateNavigation();
        this._onPrevious = () => this.scrollProducts(-1);
        this._onNext = () => this.scrollProducts(1);
        this.scroller.addEventListener('scroll', this._onScroll, { passive: true });
        this.previousButton.addEventListener('click', this._onPrevious);
        this.nextButton.addEventListener('click', this._onNext);

        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.scroller);
        requestAnimationFrame(() => this.updateNavigation());
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick, true);
        this.scroller?.removeEventListener('scroll', this._onScroll);
        this.previousButton?.removeEventListener('click', this._onPrevious);
        this.nextButton?.removeEventListener('click', this._onNext);
        this.resizeObserver?.disconnect();
      }

      onClick(event) {
        const button = event.target.closest('[data-dl-notify-me="true"]');
        if (!button || !this.contains(button)) return;

        const popupId = button.dataset.dlNotifyMePopId?.trim();
        if (!popupId) return;

        event.preventDefault();
        event.stopPropagation();
        this.showNextAvailablePopup(popupId);
      }

      showNextAvailablePopup(popupId) {
        const popup = document.getElementById(popupId);
        if (!popup || popup.tagName.toLowerCase() !== 'dl-pop-h') return;

        if (localStorage.getItem(`dl-pop-h-finished-${popupId}`)) {
          const nextPopupId = popup.btn?.dataset.dlNextPopId?.trim();
          if (nextPopupId) this.showNextAvailablePopup(nextPopupId);
          return;
        }

        popup.show?.(true);
      }

      scrollProducts(direction) {
        const card = this.scroller.querySelector('dl-product-grid-item-h');
        const styles = getComputedStyle(this.scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.scroller.clientWidth * 0.8;
        this.scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      updateNavigation() {
        const maxScrollLeft = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const hasOverflow = maxScrollLeft > 1;
        this.previousButton.hidden = !hasOverflow || this.scroller.scrollLeft <= 1;
        this.nextButton.hidden = !hasOverflow || this.scroller.scrollLeft >= maxScrollLeft - 1;
      }
    }
  );
}

if (!customElements.get('dl-product-grid-item-h')) {
  class DlProductGridItemH extends HTMLElement {
    constructor() {
      super();
      this.imageContainer = this.querySelector('.dl-product-grid-item-h-image');
      this.images = this.imageContainer.querySelectorAll('img');
      this.colorsContainer = this.querySelector('.dl-product-grid-item-h-colors');
      this.colors = this.colorsContainer.querySelectorAll('.dl-product-grid-item-h-colors-item');
      this.productForm = this.querySelector('dl-product-form-h form');
      this.formIdInput = this.querySelector('dl-product-form-h form input[name="id"]');
      this.formButton = this.querySelector('dl-product-form-h [type="submit"]');
      this.addToCartPart = this.querySelector('.dl-product-grid-item-h-add-to-cart-part');
      this.adding = false;
      this.priceContainer = this.querySelector('.dl-product-grid-item-h-prices-price');
      this.saleTag = this.querySelector('.dl-product-grid-item-h-sale');
      this.preTag = this.querySelector('.dl-product-grid-item-h-preorder');
      this.infoMain = this.querySelector('.dl-product-grid-item-h-info-main');
      this.preorderInfo = this.querySelector('.dl-product-grid-item-h-preorder-info-value');
      this.isBlogCard = Boolean(this.closest('.dl-blog-upsell'));
      this.formButtonText = this.formButton?.querySelector('span');
      this.formQuantityInput = this.querySelector('dl-product-form-h form input[name="quantity"]');
      this.imageMouseoverHandle = this.imageMouseover.bind(this);
      this.imageMouseoutHandle = this.imageMouseout.bind(this);
      this.notifyMeClickHandle = this.handleNotifyMeClick.bind(this);
      this.handleResize();
      this.bindEvents();
    }

    bindEvents() {
      if (this.colors.length > 1) {
        this.colors.forEach(color => color.addEventListener('click', this.handleColorClick.bind(this)));
      }
      if (this.isBlogCard) {
        this.formButton?.addEventListener('click', this.notifyMeClickHandle);
      }
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    imageMouseover() {
      let video = this.imageContainer.querySelector('video');
      if (video != null) {
        let loaded = true;
        video.querySelectorAll('source').forEach(source => {
          if (source.src == '') { source.src = source.dataset.dlSrc; loaded = false; }
        });
        if (!loaded) video.load();
        video.play().catch(error => console.error('Video play failed:', error));
      }
    }

    imageMouseout() {
      let video = this.imageContainer.querySelector('video');
      if (video != null) { video.pause(); video.currentTime = 0; }
    }

    handleResize() {
      if (this.handleResizing) clearTimeout(this.handleResizing);
      this.handleResizing = setTimeout(() => {
        if (window.innerWidth > 990) {
          this.imageContainer.addEventListener('mouseover', this.imageMouseoverHandle);
          this.imageContainer.addEventListener('mouseout', this.imageMouseoutHandle);
        } else {
          this.imageContainer.removeEventListener('mouseover', this.imageMouseoverHandle);
          this.imageContainer.removeEventListener('mouseout', this.imageMouseoutHandle);
        }
      }, 200);
    }

    handleColorClick(e) {
      e.stopPropagation();
      e.preventDefault();
      let color_option = e.currentTarget;
      let variant_id = color_option.dataset.dlVariantId;
      let variant_images = this.imageContainer.querySelectorAll(`img[data-dl-variant-id="${variant_id}"]`);
      this.imageContainer.classList.add('dl-change');
      this.images.forEach(image => image.classList.remove('dl-selected'));
      variant_images.forEach(image => image.classList.add('dl-selected'));
      this.colors.forEach(color => color.classList.remove('dl-selected'));
      color_option.classList.add('dl-selected');
      this.formIdInput.value = variant_id;
      let available = color_option.dataset.dlVariantAvailable;
      const showNotifyMe = available !== 'true'
        && color_option.dataset.dlVariantNotifyMe === 'true'
        && Boolean(color_option.dataset.dlVariantNotifyMePopId);
      this.formButton.disabled = available !== 'true' && !showNotifyMe;
      this.formIdInput.disabled = available !== 'true';
      if (this.formQuantityInput) this.formQuantityInput.disabled = available !== 'true';
      if (this.isBlogCard) {
        this.formButton.dataset.dlNotifyMe = showNotifyMe ? 'true' : 'false';
        this.formButton.dataset.dlNotifyMePopId = showNotifyMe
          ? color_option.dataset.dlVariantNotifyMePopId
          : '';
        if (this.formButtonText) {
          this.formButtonText.textContent = showNotifyMe
            ? this.formButton.dataset.notifyMeText
            : available === 'true'
              ? this.formButton.dataset.addToCartText
              : this.formButton.dataset.soldOutText;
        }
      }
      let variant_price = variant_images.length > 0 ? variant_images[0].dataset.dlVariantPrice : null;
      let focus_discount = this.priceContainer.dataset.dlFocusDiscount;
      if (focus_discount) variant_price = Math.ceil(Number(variant_price) * (100.0 - Number(focus_discount)) / 100.0);
      let focus_save_money = this.priceContainer.dataset.dlFocusSaveMoney;
      if (focus_save_money) variant_price = Number(variant_price) - Number(focus_save_money);
      this.priceContainer.textContent = formatMoney(variant_price);
      if (this.saleTag) {
        const hasDiscount = color_option.dataset.dlVariantHasDiscount === 'true';
        this.saleTag.textContent = color_option.dataset.dlVariantDiscountLabel || '';
        this.saleTag.style.display = hasDiscount ? '' : 'none';
      }
      if (dl_product_preorder['' + variant_id] != null) {
        if (!this.isBlogCard) this.preTag.classList.add('dl-show');
        this.infoMain.classList.add('dl-preorder');
        this.preorderInfo.innerHTML = dl_product_preorder['' + variant_id];
        const preProInput = document.createElement('input');
        preProInput.type = 'hidden';
        preProInput.name = 'properties[' + this.querySelector('.dl-product-grid-item-h-preorder').innerHTML.trim() + ']';
        preProInput.value = dl_product_preorder['' + variant_id];
        preProInput.id = 'pre-pro-input';
        this.productForm.appendChild(preProInput);
      } else {
        this.preTag.classList.remove('dl-show');
        this.infoMain.classList.remove('dl-preorder');
        const preProInput = this.productForm.querySelector('#pre-pro-input');
        if (preProInput) preProInput.remove();
      }
    }

    handleNotifyMeClick(event) {
      if (this.formButton?.dataset.dlNotifyMe !== 'true') return;
      const popupId = this.formButton.dataset.dlNotifyMePopId?.trim();
      if (!popupId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showNextAvailablePopup(popupId);
    }

    showNextAvailablePopup(popupId) {
      const popup = document.getElementById(popupId);
      if (!popup || popup.tagName.toLowerCase() !== 'dl-pop-h') return;
      if (localStorage.getItem(`dl-pop-h-finished-${popupId}`)) {
        const nextPopupId = popup.btn?.dataset.dlNextPopId?.trim();
        if (nextPopupId) this.showNextAvailablePopup(nextPopupId);
        return;
      }
      popup.show?.(true);
    }
  }
  customElements.define('dl-product-grid-item-h', DlProductGridItemH);
}
